import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent {

  constructor(private titleService: Title, private route: Router, private translate: TranslateService) {
    this.translate.setDefaultLang('it');
    if (this.translate.currentLang) {
      this.translate.use(this.translate.currentLang);
    } else {
      this.translate.use('it');
    };
    this.translate.get('breadcrumb.page_not_found').subscribe((res: string) => {
      this.titleService.setTitle(res + ' - PRIMIS');
    });
    this.translate.onLangChange.subscribe(() => {
      this.translate.get('breadcrumb.page_not_found').subscribe((res: string) => {
        this.titleService.setTitle(res + ' - PRIMIS');
      });
    });
  }
}
